import React from "react";
import { useLocation } from "react-router-dom";
import MainContentCard from "../../../Home/MainContentCard";
import ErrorBoundaryRoutes from "../../../../components/shared/ErrorBoundaryRoutes";
import UpdateLocalPurchaseOrderChild from "./UpdateLocalPurchaseOrderChild";

const UpdateLocalPurchaseOrder = () => {
  const { state } = useLocation();
  const currentRecord = state?.p_register;
  const recordId = state?._id;

  return (
    <MainContentCard>
      <ErrorBoundaryRoutes page="Update LPO" route="/update-lpo">
        <UpdateLocalPurchaseOrderChild
          currentRecord={currentRecord}
          recordId={recordId}
        />
      </ErrorBoundaryRoutes>
    </MainContentCard>
  );
};

export default UpdateLocalPurchaseOrder;
